// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__-hash-base-64-5-","Close":"Modal__Close__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/Modal/Modal.scss
// module id = 178
// module chunks = 0